import { useEffect, useState } from "react";
import { Button } from "@component/button";
import { Card, CardContent } from "@component/card";
import { CheckCircleIcon, XCircleIcon } from "lucide-react";
import { useQuery } from "@util/useQuery";
import { useNavigate } from "react-router-dom";
import { approveAssessmentLink } from "@service/job";
import BasicLayout from "@container/layout/basic";

export default function ApproveAssessmentLinkPage() {
    const queryParams = useQuery()
    const navigate = useNavigate();
    const token = queryParams.get("token") || "";
    const payloadToken = token ? JSON.parse(atob(token)) : null;
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        if (payloadToken) {
            approveAssessmentLink(payloadToken.job_id, payloadToken.user_id).then((resp) => {
                if (resp.status === 200) {
                    setIsError(false);
                }
            }).finally(() => {
                setIsLoading(false);
            }).catch(() => {
                setIsError(true);
                setIsLoading(false);
            });
        }
    }, [queryParams.get("token")]);

    return (
        <BasicLayout showFooter={false}>
            <div className="flex items-center justify-center min-h-full">
                <Card className="w-full max-w-xl">
                    <CardContent className="space-y-5 px-8 sm:px-12">
                        <div
                            className="text-center space-y-4"
                            style={{ paddingTop: "24px", paddingBottom: "0px" }}
                        >
                            <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto ${!isError ? "bg-green-100" : "bg-red-100"}`}>
                                {!isError ? (
                                    <CheckCircleIcon className="w-8 h-8 text-green-600" />
                                ) : (
                                    <XCircleIcon className="w-8 h-8 text-red-600" />
                                )}
                            </div>
                            <div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                                    {isError ? "Request failed" : "Request approved!"}
                                </h3>
                                {!isError ? (
                                    <p className="text-sm text-gray-600">
                                        You’ve successfully approved the request for a new screening link.
                                    </p>
                                ) : (
                                    <>
                                        <p className="text-sm text-gray-600">
                                            There was an error approving your request. Please try again later.
                                        </p>
                                    </>
                                )}
                            </div>
                            <div className="pt-2">
                                <Button
                                    onClick={() => navigate("/")}
                                    disabled={isLoading}
                                    className="w-full bg-blue-600 hover:bg-blue-700"
                                >
                                    Back to Dashboard
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </BasicLayout>
    );
}
